import { render, staticRenderFns } from "./CiVehicleDescription.vue?vue&type=template&id=0139d36a&"
import script from "./CiVehicleDescription.vue?vue&type=script&lang=js&"
export * from "./CiVehicleDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports